import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-[1280px] px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          {t("categories.title")}
        </h2>
        <p className="mt-3 text-foreground-600">{t("categories.subtitle")}</p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {categories.map((cat) => (
          <a
            key={cat.key}
            href={cat.href}
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
          >
            <div className="aspect-square w-full overflow-hidden bg-background-100">
              <img
                src={cat.image}
                alt={`${t(`categories.${cat.key}`)} — AllChinaBuy Spreadsheet`}
                title={`${t(`categories.${cat.key}`)} AllChinaBuy Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            {/* Text label overlaid on the image */}
            <div className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 bg-gradient-to-t from-black/70 via-black/35 to-transparent px-3 pb-3 pt-8">
              <span className="text-sm font-semibold leading-tight text-white">
                {t(`categories.${cat.key}`)}
              </span>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/20 text-white backdrop-blur transition-colors group-hover:bg-primary-500">
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}